export default __webpack_public_path__ + "static/media/citizen.a0b93c1d.png";